module.exports = __webpack_public_path__ + "img/20210325.c432a8b8.png";